// import { useState, useEffect } from "react";
// import {
//   Heart,
//   ArrowLeft,
//   Search,
//   MapPin,
//   Cake,
//   GraduationCap,
//   Briefcase,
//   Star,
//   ChevronDown,
//   Crown,
//   User,
//   Menu,
//   Sparkles,
//   Eye,
//   X,
// } from "lucide-react";
// import {
//   AlertDialog,
//   AlertDialogContent,
//   AlertDialogHeader,
//   AlertDialogFooter,
//   AlertDialogTitle,
//   AlertDialogDescription,
//   AlertDialogCancel,
//   AlertDialogAction,
// } from "./ui/alert-dialog";
// import { Button } from "./ui/button";
// import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
// import { Input } from "./ui/input";
// import { Label } from "./ui/label";
// import {
//   Select,
//   SelectContent,
//   SelectItem,
//   SelectTrigger,
//   SelectValue,
// } from "./ui/select";
// import { Slider } from "./ui/slider";
// import { Badge } from "./ui/badge";
// import {
//   Collapsible,
//   CollapsibleContent,
//   CollapsibleTrigger,
// } from "./ui/collapsible";
// import { ImageWithFallback } from "./figma/ImageWithFallback";
// // import { sampleProfiles as profiles } from "../constants/profiles";
// import { useSelector, useDispatch } from "react-redux";
// import { setUserId } from "../redux/userSlice";

// import { clearUserState } from "../redux/userSlice";
// import { ProfileCard } from "./ProfileCard";
// import {
//   getWithoutTokenAPI,
//   getWithTokenAPI,
//   postWithTokenAPI,
// } from "../util/Api";
// import { Header } from "./Header";

// export function SearchPage({ onNavigate }) {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [isInterestSent, setIsInterestSent] = useState(false);
//   const [isAdvancedOpen, setIsAdvancedOpen] = useState(false);
//   const [searchResults, setSearchResults] = useState([]);
//   const [showLogoutDialog, setShowLogoutDialog] = useState(false);
//   const [showLoginDialog, setShowLoginDialog] = useState(false);
//   const [filters, setFilters] = useState({
//     ageRange: [18, 50],
//     location: "",
//     religion: "",
//     education: "",
//   });
//   // console.log(filters,'filters state')
//   const [showsearch, setShowsearch] = useState(false);
//   const [profileList, setProfileList] = useState([]);
//   const data = useSelector((state) => state.user);
//   const token = data?.userId?.accessToken;
//   const id = data?.userId?.user?._id;
//   const dispatch = useDispatch();
//   const handleLogout = () => {
//     setShowLogoutDialog(true);
//   };
//   const [subpack, setSubsPack] = useState("");
//   const [header, setHeader] = useState(null);
//   console.log(header?.logo, "header==============");
//   useEffect(() => {
//     const fetchHeader = async () => {
//       try {
//         const response = await getWithoutTokenAPI(`/header/get_all`);
//         if (response?.data?.length) {
//           const headerData = response.data[0];
//           // Fix the image URL and set header in one call
//           const fixedHeader = {
//             ...headerData,
//             logo: headerData.logo.replace(
//               "s3.eu-north-1.amazonaws.com",
//               "s3.ap-south-1.amazonaws.com"
//             ),
//           };
//           setHeader(fixedHeader);
//         }
//       } catch (error) {
//         console.error("Error fetching header:", error);
//       }
//     };
//     fetchHeader();
//   }, []);

//   const [profileData, setprofileData] = useState("");
//   useEffect(() => {
//     const fetchProfile = async () => {
//       try {
//         const response = await getWithTokenAPI(
//           token,
//           `/user-id/get_by_id?user_id=${id}`
//         );
//         setprofileData(response?.data?.profile?.name);

//         setSubsPack(response?.data?.subscription?.plan_name);
//         console.log(response, "profileData response name");
//       } catch (error) {
//         console.error("Error fetching profile:", error);
//       }
//     };
//     if (id && token) {
//       fetchProfile();
//     }
//   }, [id, token]); // ✅ Proper dependencies
//   const [page, setPage] = useState();
//   const [count, setCount] = useState(1);

//   useEffect(() => {
//     const delayDebounce = setTimeout(() => {
//       if (searchQuery.trim() !== "") {
//         handlefiltersearch();
//       }
//     }, 100); // 500ms delay after typing stops

//     return () => clearTimeout(delayDebounce);
//   }, [searchQuery]);

//   useEffect(() => {
//     const fetchprofilesList = async () => {
//       try {
//         const response = await getWithTokenAPI(
//           token,
//           `/basic-profile/get_others?user_id=${id}&page=${count}`
//         );
//         // console.log('Profile Response',response)
//         setProfileList(response.data || []);
//         setPage(response.data.totalPages);
//         if (response?.statusCode === 200) {
//           setProfileList(response?.data?.profiles);
//         }
//       } catch {}
//     };
//     if (token && id && count) fetchprofilesList();
//   }, [token, id, count]);
//   // Add this function to fix image URLs
//   const fixImageUrl = (url) => {
//     if (!url) return "";
//     return url.replace(
//       "s3.eu-north-1.amazonaws.com",
//       "s3.ap-south-1.amazonaws.com"
//     );
//   };

//   // In your searchResults.map, update the ImageWithFallback component:

//   const handleSendInterest = () => {
//     if (!isInterestSent) {
//       setShowInterestModal(true);
//     }
//   };

//   const capitalize = (str) => {
//     if (typeof str !== "string" || !str) return "";
//     else if (str.length > 1) return str.charAt(0).toUpperCase() + str.slice(1);
//     else return str.toUpperCase();
//   };

//   const handleSearch = async () => {
//     try {
//       const payload = {
//         fromAge: filters.ageRange[0],
//         toAge: filters.ageRange[1],
//         religion: filters.religion,
//         city: filters.location,
//         district: filters.location,
//         education: filters.education,
//       };
//       console.log("payload for search filter", payload);
//       const response = await postWithTokenAPI(
//         token,
//         "/profile/filter",
//         payload
//       );
//       console.log("response", response?.data);
//       if (response?.statusCode == 200) {
//         setSearchResults(response.data.profiles);
//         setShowsearch(true);
//         console.log(searchResults, "searched result");
//       }
//     } catch (error) {}
//     // setSearchResults(filtered);
//   };

//   const handlefiltersearch = async () => {
//     try {
//       const payload = {
//         search: searchQuery,
//       };
//       const params = new URLSearchParams(payload).toString();
//       const response = await getWithTokenAPI(
//         token,
//         `/basic-profile/get_all?${params}`
//       );
//       if (response?.statusCode == 200) {
//         setSearchResults(response?.data?.profiles);
//         setShowsearch(true);
//       }
//     } catch (error) {}
//   };

//   return (
//     <div className="min-h-screen bg-background">
//       {/* Header */}
//       {/* <div className="bg-white shadow-sm border-b border-border sticky top-0 z-40">
//         <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex justify-between items-center h-16">
//             <button
//               onClick={() => onNavigate("home")}
//               className="flex items-center space-x-2 hover:opacity-80 transition-opacity"
//             >
//               <ArrowLeft className="h-5 w-5" />
//               <Heart className="h-8 w-8 text-red-500" />
//               <span className="text-xl font-semibold text-primary">
//                 SoulMate
//               </span>
//             </button>
//           </div>
//         </div>
//       </div> */}
//       <header className="bg-white shadow-sm border-b border-border sticky top-0 z-50">
//         <div className="max-w-7.5xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex justify-between items-center h-16">
//             {/* Logo */}
//             <div
//               className="flex items-center space-x-2 cursor-pointer"
//               onClick={() => onNavigate?.("home")}
//             >
//               {header && (
//                 <img
//                   src={header.logo}
//                   alt="AvanAval Logo"
//                   className="w-16 h-16"
//                 />
//               )}
//               <span className="text-xl font-semibold text-primary">
//                 AvanAval
//               </span>
//               <span className="text-sm text-orange-600 font-medium">தமிழ்</span>
//             </div>

//             {/* Desktop Navigation */}
//             <nav className="hidden md:flex items-center space-x-8">
//               {/* <button
//                 onClick={() => onNavigate?.("browse")}
//                 className="text-muted-foreground hover:text-primary transition-colors cursor-pointer"
//               >
//                 Browse
//               </button> */}
//               <button
//                 onClick={() => onNavigate?.("search")}
//                 className="text-lg font-semibold text-orange-600 hover:text-orange-700 cursor-pointer"
//               >
//                 Explore
//               </button>
//               <button
//                 onClick={() => onNavigate?.("matches")}
//                 className="text-muted-foreground hover:text-primary transition-colors cursor-pointer"
//               >
//                 Matches
//               </button>
//               <button
//                 onClick={() => onNavigate?.("messages")}
//                 className="text-muted-foreground hover:text-primary transition-colors cursor-pointer"
//               >
//                 Messages
//               </button>
//               <button
//                 onClick={() => onNavigate?.("subscription")}
//                 className="text-purple-600 hover:text-purple-700 transition-colors flex items-center gap-1 cursor-pointer"
//               >
//                 <Crown className="w-4 h-4" />
//                 Subscription
//               </button>
//             </nav>

//             {/* Desktop Auth Buttons */}
//             <div className="hidden md:flex items-center space-x-4 cursor-pointer">
//               <Button
//                 variant="ghost"
//                 onClick={() => onNavigate?.("profile")}
//                 className="flex items-center gap-2 cursor-pointer"
//               >
//                 {subpack === "Elite" ? (
//                   <Crown className="w-4 h-4 text-purple-500" />
//                 ) : subpack === "Premium" ? (
//                   <Star className="w-4 h-4 text-blue-500" />
//                 ) : (
//                   <User className="w-4 h-4" />
//                 )}
//                 {profileData ? profileData : "Profile"}
//               </Button>
//               {/* <Button
//               variant="ghost"
//               onClick={() => onNavigate?.("admin")}
//               className="flex items-center gap-2 text-blue-600 hover:text-blue-700"
//             >
//               <Shield className="w-4 h-4" />
//               Admin
//             </Button> */}
//               <Button
//                 variant="ghost"
//                 className="justify-start cursor-pointer"
//                 onClick={() => {
//                   if (data) {
//                     handleLogout();
//                     // onNavigate("Login"); // 👈 Logout action
//                   } else {
//                     onNavigate?.("login"); // 👈 Go to login page
//                   }
//                 }}
//               >
//                 {data ? "Logout" : "Login"}
//               </Button>
//               {/* <Button onClick={() => onNavigate?.("register")}>
//               பதிவு செய்யவும்
//             </Button> */}
//             </div>

//             {/* Mobile Menu Button */}
//             <div className="md:hidden">
//               <Button
//                 variant="ghost"
//                 size="sm"
//                 onClick={() => setIsMenuOpen(!isMenuOpen)}
//               >
//                 {isMenuOpen ? (
//                   <X className="h-6 w-6" />
//                 ) : (
//                   <Menu className="h-6 w-6" />
//                 )}
//               </Button>
//             </div>
//           </div>

//           {/* Mobile Navigation */}
//           {isMenuOpen && (
//             <div className="md:hidden py-4 border-t border-border">
//               <nav className="flex flex-col space-y-4">
//                 {/* <button
//                   onClick={() => onNavigate?.("browse")}
//                   className="text-muted-foreground hover:text-primary transition-colors text-left cursor-pointer"
//                 >
//                   Browse
//                 </button> */}
//                 <button
//                   onClick={() => onNavigate?.("search")}
//                   className="text-lg font-semibold text-orange-600 hover:text-orange-700 cursor-pointer"
//                 >
//                   Explore
//                 </button>
//                 <button
//                   onClick={() => onNavigate?.("matches")}
//                   className="text-muted-foreground hover:text-primary transition-colors text-left cursor-pointer"
//                 >
//                   Matches
//                 </button>
//                 <button
//                   onClick={() => onNavigate?.("messages")}
//                   className="text-muted-foreground hover:text-primary transition-colors text-left cursor-pointer"
//                 >
//                   Messages
//                 </button>
//                 <button
//                   onClick={() => onNavigate?.("subscription")}
//                   className="text-purple-600 hover:text-purple-700 transition-colors text-left flex items-center gap-1 cursor-pointer"
//                 >
//                   <Crown className="w-4 h-4" />
//                   Subscription
//                 </button>
//                 <div className="flex flex-col space-y-2 pt-4 border-t border-border cursor-pointer">
//                   <Button
//                     variant="ghost"
//                     className="justify-start cursor-pointer"
//                     onClick={() => onNavigate?.("profile")}
//                   >
//                     {subpack === "Elite" ? (
//                       <Crown className="w-4 h-4 text-purple-500" />
//                     ) : subpack === "Premium" ? (
//                       <Star className="w-4 h-4 text-blue-500" />
//                     ) : (
//                       <User className="w-4 h-4" />
//                     )}
//                     {profileData ? profileData : "Profile"}
//                   </Button>
//                   {/* <Button
//                   variant="ghost"
//                   className="justify-start text-blue-600"
//                   onClick={() => onNavigate?.("admin")}
//                 >
//                   <Shield className="w-4 h-4 mr-2" />
//                   Admin
//                 </Button> */}
//                   <Button
//                     variant="ghost"
//                     className="justify-start cursor-pointer"
//                     onClick={() => {
//                       if (data) {
//                         handleLogout(); // 👈 Logout action
//                         // onNavigate("Login");
//                       } else {
//                         onNavigate?.("login"); // 👈 Go to login page
//                       }
//                     }}
//                   >
//                     {data ? `Logout` : "Login"}
//                   </Button>
//                   {/* <Button
//                   className="justify-start"
//                   onClick={() => onNavigate?.("register")}
//                 >
//                   Register
//                 </Button> */}
//                 </div>
//               </nav>
//             </div>
//           )}
//         </div>
//         <AlertDialog open={showLogoutDialog} onOpenChange={setShowLogoutDialog}>
//           <AlertDialogContent>
//             <AlertDialogHeader>
//               <AlertDialogTitle>Logout</AlertDialogTitle>
//               <AlertDialogDescription>
//                 Are you sure to logout {profileData}?
//               </AlertDialogDescription>
//             </AlertDialogHeader>
//             <AlertDialogFooter>
//               <AlertDialogCancel onClick={() => setShowLogoutDialog(false)}>
//                 Cancel
//               </AlertDialogCancel>
//               <AlertDialogAction
//                 className="bg-red-500 hover:bg-red-600"
//                 onClick={() => {
//                   setShowLogoutDialog(false);
//                   dispatch(clearUserState(null));
//                   localStorage.removeItem("UserId");
//                   onNavigate("Home"); // 👈 navigate to login screen
//                 }}
//               >
//                 Logout
//               </AlertDialogAction>
//             </AlertDialogFooter>
//           </AlertDialogContent>
//         </AlertDialog>
//       </header>
//       <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//         <div className="mb-8">
//           <h1 className="text-2xl font-semibold mb-2">Advanced Search</h1>
//           <p className="text-muted-foreground">
//             Find your perfect match with detailed preferences
//           </p>
//         </div>
// {
//   /* Hero Section */
// }
// <div className="text-center mb-12">
//   <div className="inline-flex items-center gap-2 bg-blue-50 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
//     <Sparkles className="w-4 h-4" />
//     Find Your Perfect Match
//   </div>
//   <h1 className="text-4xl font-bold text-gray-900 mb-4">
//     Discover Your <span className="text-red-500">Soulmate</span>
//   </h1>
//   <p className="text-xl text-gray-600 max-w-2xl mx-auto">
//     Advanced search with smart filters to find compatible partners
//   </p>
// </div>;
//         {/* Search Form */}
//         <Card className="mb-8">
//           <CardHeader>
//             <CardTitle className="flex items-center space-x-2">
//               <Search className="h-5 w-5" />
//               <span>Search Criteria</span>
//             </CardTitle>
//           </CardHeader>
//           <CardContent className="space-y-6 ">
//             {/* Basic Search */}
//             <div>
//               <Label htmlFor="search" className="text-base mb-3 block">
//                 Quick Search
//               </Label>
//               <div className="flex gap-3">
//                 <Input
//                   id="search"
//                   placeholder="Search by name or location"
//                   value={searchQuery}
//                   onChange={(e) => setSearchQuery(e.target.value)}
//                   className="flex-1"
//                 />
//                 <Button
//                   // onClick={
//                   //   token
//                   //     ? handlefiltersearch
//                   //     : () => {
//                   //         setShowLoginDialog(true);
//                   //       }
//                   // }
//                   className="bg-red-500 hover:bg-red-600"
//                 >
//                   {/* <Search className="h-4 w-4 mr-2" /> */}
//                   Search
//                 </Button>
//               </div>
//             </div>

//             {/* Advanced Filters */}
//             <Collapsible open={isAdvancedOpen} onOpenChange={setIsAdvancedOpen}>
//               <CollapsibleTrigger asChild>
//                 <Button variant="outline" className="w-full">
//                   <span>Advanced Filters</span>
//                   <ChevronDown
//                     className={`h-4 w-4 ml-2 transition-transform ${
//                       isAdvancedOpen ? "rotate-180" : ""
//                     }`}
//                   />
//                 </Button>
//               </CollapsibleTrigger>
//               <CollapsibleContent className="space-y-6 pt-6">
//                 <div className="grid grid-cols-1 gap-6">
//                   <div className="grid sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-4  gap-6">
//                     <div>
//                       <Label className="text-sm mb-3 block">Age Range</Label>
//                       <Slider
//                         value={filters.ageRange}
//                         onValueChange={(value) =>
//                           setFilters({ ...filters, ageRange: value })
//                         }
//                         min={18}
//                         max={50}
//                         step={1}
//                         className="mb-2"
//                       />
//                       <div className="flex justify-between text-xs text-muted-foreground">
//                         <span>{filters.ageRange[0]} years</span>
//                         <span>{filters.ageRange[1]} years</span>
//                       </div>
//                     </div>

//                     <div>
//                       <Label className="text-sm mb-3 block">Religion</Label>
//                       <Input
//                         placeholder="Enter Religion"
//                         value={filters.religion}
//                         onChange={(e) =>
//                           setFilters({ ...filters, religion: e.target.value })
//                         }
//                         className="flex-1"
//                       />
//                     </div>

//                     <div>
//                       <Label className="text-sm mb-3 block">Location</Label>
//                       <Input
//                         placeholder="Enter Location"
//                         value={filters.location}
//                         onChange={(e) =>
//                           setFilters({ ...filters, location: e.target.value })
//                         }
//                         className="flex-1"
//                       />
//                     </div>

//                     <div>
//                       <Label className="text-sm mb-3 block">Education</Label>
//                       <Input
//                         placeholder="Enter Qualification"
//                         value={filters.education}
//                         onChange={(e) =>
//                           setFilters({ ...filters, education: e.target.value })
//                         }
//                         className="flex-1"
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="flex gap-3">
//                   <Button
//                     onClick={
//                       token
//                         ? handleSearch
//                         : () => {
//                             setShowLoginDialog(true);
//                           }
//                     }
//                     className="bg-red-500 hover:bg-red-600"
//                   >
//                     Featured Search
//                   </Button>
//                   <Button
//                     variant="outline"
//                     onClick={() => {
//                       setSearchQuery("");
//                       setFilters({
//                         ageRange: [18, 50],
//                         location: "",
//                         religion: "",
//                         education: "",
//                       });
//                       setSearchResults([]);
//                     }}
//                   >
//                     Clear All
//                   </Button>
//                 </div>
//               </CollapsibleContent>
//             </Collapsible>
//           </CardContent>
//         </Card>
//        {/* Redesigned Search Section */}
//       <div className="max-w-7.5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//          {/* Hero Section */}
//          <div className="text-center mb-12">
//            <div className="inline-flex items-center gap-2 bg-blue-50 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
//              <Sparkles className="w-4 h-4" />
//              Find Your Perfect Match
//            </div>
//            <h1 className="text-4xl font-bold text-gray-900 mb-4">
//              Discover Your <span className="text-red-500">Soulmate</span>
//            </h1>
//            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
//              Advanced search with smart filters to find compatible partners
//            </p>
//          </div>

//          {/* Enhanced Search Card */}
//          <Card className="mb-8 border-0 shadow-2xl bg-white/80 backdrop-blur-sm rounded-2xl overflow-hidden">
//            <CardContent className="p-0">
//              {/* Quick Search Bar - Premium Design */}
//              <div className="bg-gradient-to-r from-red-500 to-red-600 p-6">
//                <div className="max-w-4xl mx-auto">
//                  <Label
//                   htmlFor="search"
//                   className="text-white font-semibold text-lg mb-4 block text-center"
//                 >
//                   Start Your Search Journey
//                 </Label>
//                 <div className="flex gap-3">
//                   <div className="flex-1 relative">
//                     {/* <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" /> */}
//                     <Input
//                       id="search"
//                       placeholder="Search by name, location, profession, interests..."
//                       value={searchQuery}
//                       onChange={(e) => setSearchQuery(e.target.value)}
//                       className="pl-12 pr-4 py-3 text-lg border-0 shadow-lg rounded-xl bg-white focus:ring-2 focus:ring-red-300"
//                     />
//                   </div>
//                   <Button
//                     onClick={
//                       token
//                         ? handlefiltersearch
//                         : () => setShowLoginDialog(true)
//                     }
//                     className="bg-white text-red-600 hover:bg-gray-100 px-8 py-3 rounded-xl font-semibold shadow-lg transition-all duration-200 hover:scale-105"
//                   >
//                     <Zap className="w-5 h-5 mr-2" />
//                     Search
//                   </Button>
//                 </div>
//               </div>
//             </div>

//             {/* Advanced Filters Section */}
//             <div className="p-6">
//               <Collapsible
//                 open={isAdvancedOpen}
//                 onOpenChange={setIsAdvancedOpen}
//               >
//                 <div className="text-center mb-6">
//                   <CollapsibleTrigger asChild>
//                     <Button
//                       variant="outline"
//                       className="border-2 border-dashed border-gray-300 bg-white hover:bg-gray-50 rounded-xl px-8 py-3 text-lg font-semibold transition-all duration-200 hover:border-red-300"
//                     >
//                       <SlidersHorizontal className="w-5 h-5 mr-3" />
//                       Advanced Filters
//                       <ChevronDown
//                         className={`h-5 w-5 ml-2 transition-transform ${
//                           isAdvancedOpen ? "rotate-180" : ""
//                         }`}
//                       />
//                     </Button>
//                   </CollapsibleTrigger>
//                 </div>

//                 <CollapsibleContent className="space-y-8">
//                   {/* Filter Grid - Modern Layout */}
//                   <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
//                     {/* Left Column - Age Range */}
//                     <div className="space-y-6">
//                       <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-6 border border-blue-100">
//                         <div className="flex items-center gap-3 mb-4">
//                           <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
//                             <Cake className="w-5 h-5 text-blue-600" />
//                           </div>
//                           <div>
//                             <Label className="text-lg font-semibold text-gray-900 block">
//                               Age Range
//                             </Label>
//                             <p className="text-sm text-gray-600">
//                               Select preferred age range
//                             </p>
//                           </div>
//                         </div>
//                         <div className="space-y-4">
//                           <Slider
//                             value={filters.ageRange}
//                             onValueChange={(value) =>
//                               setFilters({ ...filters, ageRange: value })
//                             }
//                             min={18}
//                             max={50}
//                             step={1}
//                             className="mb-2"
//                           />
//                           <div className="flex justify-between items-center">
//                             <div className="text-center">
//                               <div className="text-2xl font-bold text-blue-600">
//                                 {filters.ageRange[0]}
//                               </div>
//                               <div className="text-sm text-gray-500">
//                                 Min Age
//                               </div>
//                             </div>
//                             <div className="w-8 h-0.5 bg-gray-300"></div>
//                             <div className="text-center">
//                               <div className="text-2xl font-bold text-blue-600">
//                                 {filters.ageRange[1]}
//                               </div>
//                               <div className="text-sm text-gray-500">
//                                 Max Age
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>

//                       {/* Religion Filter */}
//                       <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-6 border border-green-100">
//                         <div className="flex items-center gap-3 mb-4">
//                           <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
//                             <Target className="w-5 h-5 text-green-600" />
//                           </div>
//                           <div>
//                             <Label className="text-lg font-semibold text-gray-900 block">
//                               Religion
//                             </Label>
//                             <p className="text-sm text-gray-600">
//                               Preferred religious background
//                             </p>
//                           </div>
//                         </div>
//                         <Input
//                           placeholder="e.g., Hindu, Muslim, Christian..."
//                           value={filters.religion}
//                           onChange={(e) =>
//                             setFilters({ ...filters, religion: e.target.value })
//                           }
//                           className="border-green-200 focus:border-green-400 rounded-lg py-2"
//                         />
//                       </div>
//                     </div>

//                     {/* Right Column - Location & Education */}
//                     <div className="space-y-6">
//                       {/* Location Filter */}
//                       <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-6 border border-purple-100">
//                         <div className="flex items-center gap-3 mb-4">
//                           <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
//                             <MapPin className="w-5 h-5 text-purple-600" />
//                           </div>
//                           <div>
//                             <Label className="text-lg font-semibold text-gray-900 block">
//                               Location
//                             </Label>
//                             <p className="text-sm text-gray-600">
//                               City, district or area
//                             </p>
//                           </div>
//                         </div>
//                         <Input
//                           placeholder="e.g., Chennai, Madurai, Coimbatore..."
//                           value={filters.location}
//                           onChange={(e) =>
//                             setFilters({ ...filters, location: e.target.value })
//                           }
//                           className="border-purple-200 focus:border-purple-400 rounded-lg py-2"
//                         />
//                       </div>

//                       {/* Education Filter */}
//                       <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-6 border border-orange-100">
//                         <div className="flex items-center gap-3 mb-4">
//                           <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center">
//                             <GraduationCap className="w-5 h-5 text-orange-600" />
//                           </div>
//                           <div>
//                             <Label className="text-lg font-semibold text-gray-900 block">
//                               Education
//                             </Label>
//                             <p className="text-sm text-gray-600">
//                               Educational qualification
//                             </p>
//                           </div>
//                         </div>
//                         <Input
//                           placeholder="e.g., Engineering, MBA, Doctor..."
//                           value={filters.education}
//                           onChange={(e) =>
//                             setFilters({
//                               ...filters,
//                               education: e.target.value,
//                             })
//                           }
//                           className="border-orange-200 focus:border-orange-400 rounded-lg py-2"
//                         />
//                       </div>
//                     </div>
//                   </div>

//                   {/* Quick Filter Chips */}
//                   <div className="max-w-4xl mx-auto">
//                     <Label className="text-lg font-semibold text-gray-900 block text-center mb-4">
//                       Quick Filters
//                     </Label>
//                     <div className="flex flex-wrap gap-3 justify-center">
//                       {[
//                         { label: "Same Caste", value: "same-caste" },
//                         { label: "Working Professional", value: "working" },
//                         { label: "Higher Education", value: "higher-ed" },
//                         { label: "Nearby Location", value: "nearby" },
//                         { label: "Similar Interests", value: "interests" },
//                       ].map((filter) => (
//                         <Badge
//                           key={filter.value}
//                           variant="secondary"
//                           className="px-4 py-2 rounded-full bg-gray-100 text-gray-700 hover:bg-gray-200 cursor-pointer transition-colors"
//                         >
//                           {filter.label}
//                         </Badge>
//                       ))}
//                     </div>
//                   </div>

//                   {/* Action Buttons */}
//                   <div className="flex justify-center gap-4 pt-6 border-t border-gray-200">
//                     <Button
//                       onClick={
//                         token ? handleSearch : () => setShowLoginDialog(true)
//                       }
//                       className="bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white px-10 py-3 rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-105"
//                     >
//                       <Target className="w-5 h-5 mr-2" />
//                       Apply Filters
//                     </Button>
//                     <Button
//                       variant="outline"
//                       onClick={() => {
//                         setSearchQuery("");
//                         setFilters({
//                           ageRange: [18, 50],
//                           location: "",
//                           religion: "",
//                           education: "",
//                         });
//                         setSearchResults([]);
//                         setShowsearch(false);
//                       }}
//                       className="border-2 border-gray-300 text-gray-700 hover:bg-gray-50 px-8 py-3 rounded-xl font-semibold transition-all duration-200"
//                     >
//                       Reset All
//                     </Button>
//                   </div>
//                 </CollapsibleContent>
//               </Collapsible>
//             </div>
//           </CardContent>
//         </Card>

//         {/* Results */}
//         {!searchResults || showsearch ? (
//           <div className="mb-6">
//             <h2 className="text-2xl font-semi-bold mb-1">Search Results</h2>
//             <p className="text-muted-foreground">
//               {searchResults.length} profiles found
//             </p>
//           </div>
//         ) : null}

//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//           {searchResults.map((profile) => (
//             <Card
//               key={profile.id}
//               className="overflow-hidden hover:shadow-lg transition-shadow group cursor-pointer"
//             >
//               <div className="relative">
//                 {/* "profileImage": "https://ivalinmabia-documents.s3.eu-north-1.amazonaws.com/uploads/67894a7a-c235-4ed2-b380-414b001a1ba3-20250608_190857.jpg", */}
//                 {/* <ImageWithFallback
//                   src={profile.profileImage}
//                   alt={profile.name}
//                   className="w-full h-64 object-cover"
//                 /> */}
//                 <ImageWithFallback
//                   src={fixImageUrl(profile.profileImage)}
//                   alt={profile.name}
//                   className="w-full h-64 object-cover"
//                 />
//                 {/* <div className="absolute top-3 left-3 flex gap-2">
//                   <Badge className="bg-green-500">Online</Badge>
//                   <Badge
//                     variant="secondary"
//                     className="flex items-center space-x-1"
//                   >
//                     <Star className="h-3 w-3 fill-current" />
//                     <span>Premium</span>
//                   </Badge>
//                 </div> */}
//                 <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
//                   <div className="absolute bottom-4 left-4 right-4 space-y-2">
//                     <Button
//                       className="w-full bg-white text-black hover:bg-gray-100"
//                       onClick={async () => {
//                         try {
//                           onNavigate?.("view-profile", profile.user_id);
//                           const payload = {
//                             viewer_id: id,
//                             viewed_id: profile.user_id,
//                           };
//                           const response = await postWithTokenAPI(
//                             token,
//                             `/profile-view/track`,
//                             payload
//                           );
//                           if (response?.statusCode == 200) {
//                             console.log("viewer count updated");
//                           } else {
//                             console.log("error in updating viewer count");
//                           }
//                         } catch (error) {
//                           console.error("Error in viewed profile post");
//                         }
//                       }}
//                     >
//                       View Full Profile
//                     </Button>
//                     <Button
//                       variant="outline"
//                       size="sm"
//                       className={
//                         isInterestSent
//                           ? "w-full bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600"
//                           : "w-full bg-white text-black hover:bg-red-50"
//                       }
//                       onClick={async () => {
//                         try {
//                           const payload = {
//                             from_user_id: id,
//                             to_user_id: profile?.user_id,
//                           };
//                           console.log("Payload for interest", payload);
//                           const response = await postWithTokenAPI(
//                             token,
//                             `/interest/create`,
//                             payload
//                           );

//                           if (response?.statusCode === 200) {
//                             setIsInterestSent(true);
//                           }
//                         } catch (error) {
//                           console.log("error in sending Interest");
//                         }
//                       }}
//                     >
//                       <Heart className="w-4 h-4 mr-2" />
//                       {isInterestSent ? "Interest Sent" : "send Interest"}
//                     </Button>
//                   </div>
//                 </div>
//               </div>

//               <CardContent className="p-4">
//                 <div className="flex items-start justify-between mb-3">
//                   <div>
//                     <h3 className="text-lg mb-1">{profile.name}</h3>
//                     <div className="flex items-center text-muted-foreground text-sm space-x-3">
//                       <span className="flex items-center space-x-1">
//                         <Cake className="h-4 w-4" />
//                         <span>{profile.age}y</span>
//                       </span>
//                       <span className="flex items-center space-x-1">
//                         <MapPin className="h-4 w-4" />
//                         <span>{capitalize(profile.district)}</span>
//                       </span>
//                     </div>
//                   </div>
//                   <Badge variant="secondary">
//                     {capitalize(profile.religion)}
//                   </Badge>
//                 </div>

//                 {/* <div className="space-y-2 text-sm">
//                   <div className="flex items-center space-x-1 text-muted-foreground">
//                     <GraduationCap className="h-3 w-3" />
//                     <span>{profile.education}</span>
//                   </div>
//                   <div className="flex items-center space-x-1 text-muted-foreground">
//                     <Briefcase className="h-3 w-3" />
//                     <span>{profile.profession}</span>
//                   </div>
//                 </div> */}

//                 {/* <div className="flex justify-between items-center mt-4 pt-3 border-t border-border">
//                   <span className="text-xs text-muted-foreground">
//                     Match: 94%
//                   </span>
//                   <span className="text-xs text-green-600">
//                     Recently Active
//                   </span>
//                 </div> */}
//               </CardContent>
//             </Card>
//           ))}
//         </div>

//         {searchResults.length == 0 && showsearch ? (
//           <div className="text-center py-12">
//             <Search className="h-12 w-12 mx-auto text-muted-foreground mb-4" />
//             <h3 className="text-lg mb-2">No profiles found for Search</h3>
//             <p className="text-muted-foreground mb-4">
//               Try adjusting your search criteria or filters
//             </p>
//             <Button
//               variant="outline"
//               onClick={() => {
//                 setSearchQuery("");
//                 setFilters({
//                   ageRange: [18, 50],
//                   location: "",
//                   religion: "",
//                   education: "",
//                 });
//                 setSearchResults([]);
//               }}
//             >
//               Clear All Filters
//             </Button>
//           </div>
//         ) : null}
//       </div>
//       <section className="py-12 px-4 sm:px-6 lg:px-8">
//         <div className="max-w-8xl mx-auto">
//           <div className="text-center mb-8">
//             <h2 className="text-2xl font-semibold mb-4">Featured Profiles</h2>
//             <p className="text-muted-foreground max-w-2xl mx-auto">
//               Discover verified profiles of potential life partners who share
//               your values and interests
//             </p>
//           </div>

//           <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//             {profileList.length > 0 ? (
//               profileList.map((profile) => (
//                 <ProfileCard
//                   key={profile._id}
//                   profile={profile}
//                   onNavigate={onNavigate}
//                 />
//               ))
//             ) : (
//               <p className="text-center col-span-full text-gray-500">
//                 No profiles found.
//               </p>
//             )}
//           </div>

//           {count != +page ? (
//             <div className="text-center mt-8">
//               <button
//                 className="bg-primary text-primary-foreground px-8 py-3 rounded-lg hover:bg-primary/90 transition-colors"
//                 onClick={() => {
//                   setCount(count + 1);
//                   if (!token) {
//                     setShowLoginDialog(true);
//                   }
//                 }}
//               >
//                 View More Profiles
//               </button>
//             </div>
//           ) : null}
//         </div>
//         <AlertDialog open={showLoginDialog} onOpenChange={setShowLoginDialog}>
//           <AlertDialogContent>
//             <AlertDialogHeader>
//               <AlertDialogTitle>Login</AlertDialogTitle>
//               <AlertDialogDescription>
//                 Login to View More
//               </AlertDialogDescription>
//             </AlertDialogHeader>
//             <AlertDialogFooter>
//               <AlertDialogCancel onClick={() => setShowLoginDialog(false)}>
//                 Cancel
//               </AlertDialogCancel>
//               <AlertDialogAction
//                 className="bg-red-500 hover:bg-red-600"
//                 onClick={() => {
//                   setShowLoginDialog(false);
//                   onNavigate("login"); // 👈 navigate to login screen
//                 }}
//               >
//                 Login
//               </AlertDialogAction>
//             </AlertDialogFooter>
//           </AlertDialogContent>
//         </AlertDialog>
//       </section>
//     </div>
//   );
import { useState, useEffect } from "react";
import {
  Heart,
  ArrowLeft,
  Search,
  MapPin,
  Cake,
  GraduationCap,
  Briefcase,
  Star,
  ChevronDown,
  Crown,
  User,
  Menu,
  Sparkles,
  Eye,
  X,
  Zap,
  SlidersHorizontal,
  Target,
} from "lucide-react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
} from "./ui/alert-dialog";
import { Button } from "./ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { Slider } from "./ui/slider";
import { Badge } from "./ui/badge";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "./ui/collapsible";
import { ImageWithFallback } from "./figma/ImageWithFallback";
import { useSelector, useDispatch } from "react-redux";
import { clearUserState } from "../redux/userSlice";
import { ProfileCard } from "./ProfileCard";
import {
  getWithoutTokenAPI,
  getWithTokenAPI,
  postWithTokenAPI,
} from "../util/Api";
import { Footer } from "./Footer";
import { Header } from "./Header";
import toast from "react-hot-toast";
import { Toaster } from "react-hot-toast";

export function SearchPage({ onNavigate }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isInterestSent, setIsInterestSent] = useState(false);
  const [sentInterest, setsentInterest] = useState(false);
  const [isAdvancedOpen, setIsAdvancedOpen] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const [filters, setFilters] = useState({
    ageRange: [18, 50],
    location: "",
    religion: "",
    education: "",
  });
  const [showsearch, setShowsearch] = useState(false);
  const [profileList, setProfileList] = useState([]);
  const data = useSelector((state) => state.user);
  const token = data?.userId?.accessToken;
  const id = data?.userId?.user?._id;
  const dispatch = useDispatch();
  const [subpack, setSubsPack] = useState("");
  const [header, setHeader] = useState(null);
  const [profileData, setprofileData] = useState("");
  const [page, setPage] = useState();
  const [count, setCount] = useState(1);

  const handleLogout = () => {
    setShowLogoutDialog(true);
  };

  //------------fetch interset------------
  // useEffect(() => {
  //   const fetchInterests = async () => {
  //     try {
  //       const sentresponse = await getWithTokenAPI(
  //         token,
  //         `/interest/get_send_interest?user_id=${id}`
  //       );

  //       if (sentresponse?.data?.receivers?.length) {
  //         const receivers = sentresponse.data.receivers;

  //         // ✅ Check if the viewed profile already received interest from this user
  //         const isAlreadySent = receivers.some(
  //           (item) => item.user_id === searchResults.id
  //         );

  //         setsentInterest(isAlreadySent);
  //       } else {
  //         setsentInterest(false);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching interests:", error);
  //       setsentInterest(false);
  //     }
  //   };

  //   if (id && token && searchResults.id) {
  //     fetchInterests();
  //   }
  // }, []);
  const [completion, setCompletion] = useState(0);
  //-----------fetch all forcompletion bar
  // useEffect(() => {
  //   const fetchAllDetails = async () => {
  //     const response = await getWithTokenAPI(token, `/profile/get_all/${id}`);
  //     if (!response?.data) return;

  //     const { basicProfile, professionalProfile, preference, zodiac } =
  //       response.data;

  //     let completion = 0;

  //     if (basicProfile) completion = 1;
  //     if (professionalProfile) completion = 2;
  //     if (preference) completion = 3;

  //     // ✅ Check if all rasi houses are filled (not empty arrays)
  //     if (zodiac && zodiac.rasi) {
  //       const allHouses = Object.values(zodiac.rasi);
  //       const hasData = allHouses.some((house) => house && house.length > 0);

  //       if (hasData) {
  //         completion = 4;
  //       }
  //     }

  //     setCompletion(completion);
  //   };

  //   fetchAllDetails();
  // }, [token, id]);

  // useEffect(() => {
  //   const fetchHeader = async () => {
  //     try {
  //       const response = await getWithoutTokenAPI(`/header/get_all`);
  //       if (response?.data?.length) {
  //         const headerData = response.data[0];
  //         const fixedHeader = {
  //           ...headerData,
  //           logo: headerData.logo.replace(
  //             "s3.eu-north-1.amazonaws.com",
  //             "s3.ap-south-1.amazonaws.com"
  //           ),
  //         };
  //         setHeader(fixedHeader);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching header:", error);
  //     }
  //   };
  //   fetchHeader();
  // }, []);

  // useEffect(() => {
  //   const fetchProfile = async () => {
  //     try {
  //       const response = await getWithTokenAPI(
  //         token,
  //         `/user-id/get_by_id?user_id=${id}`
  //       );
  //       setprofileData(response?.data?.profile?.name);
  //       setSubsPack(response?.data?.subscription?.plan_name);
  //     } catch (error) {
  //       console.error("Error fetching profile:", error);
  //     }
  //   };
  //   if (id && token) {
  //     fetchProfile();
  //   }
  // }, [id, token]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchQuery.trim() !== "") {
        handlefiltersearch();
      }
    }, 100);

    return () => clearTimeout(delayDebounce);
  }, [searchQuery]);

  useEffect(() => {
    const fetchprofilesList = async () => {
      try {
        const response = await getWithTokenAPI(
          token,
          `/basic-profile/get_others?user_id=${id}&page=${count}`
        );
        setProfileList(response.data || []);
        setPage(response.data.totalPages);
        if (response?.statusCode === 200) {
          setProfileList(response?.data?.profiles);
        }
      } catch (error) {
        console.error("Error fetching profiles:", error);
      }
    };
    if (token && id && count) fetchprofilesList();
  }, [token, id, count]);

  // useEffect(() => {
  //   const fetchTrendList = async () => {
  //     try {
  //       const presponse = await getWithoutTokenAPI(`/basic-profile/get_all`);

  //       if (presponse?.statusCode === 200) {
  //         setProfileList(presponse?.data?.profiles || []);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching trending or profile list:", error);
  //     }
  //   };

  //   fetchTrendList();
  // }, []);

  const fixImageUrl = (url) => {
    if (!url) return "";
    return url.replace(
      "s3.eu-north-1.amazonaws.com",
      "s3.ap-south-1.amazonaws.com"
    );
  };

  const capitalize = (str) => {
    if (typeof str !== "string" || !str) return "";
    else if (str.length > 1) return str.charAt(0).toUpperCase() + str.slice(1);
    else return str.toUpperCase();
  };

  const handleSearch = async () => {
    try {
      const payload = {
        fromAge: filters.ageRange[0],
        toAge: filters.ageRange[1],
        religion: filters.religion,
        city: filters.location,
        district: filters.location,
        education: filters.education,
      };
      const response = await postWithTokenAPI(
        token,
        "/profile/filter",
        payload
      );
      if (response?.statusCode == 200) {
        setSearchResults(response.data.profiles);
        setShowsearch(true);
      }
    } catch (error) {
      console.error("Error in search:", error);
    }
  };

  const handlefiltersearch = async () => {
    try {
      const payload = {
        search: searchQuery,
      };
      const params = new URLSearchParams(payload).toString();
      const response = await getWithTokenAPI(
        token,
        `/basic-profile/get_all?${params}`
      );
      if (response?.statusCode == 200) {
        setSearchResults(response?.data?.profiles);
        setShowsearch(true);
      }
    } catch (error) {
      console.error("Error in filter search:", error);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <Toaster position="top-right" />
      {/* Main Content */}
      <div className="max-w-7.5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Hero Section */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-blue-50 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
            <Sparkles className="w-4 h-4" />
            Find Your Perfect Match
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Discover Your <span className="text-red-500">Perfect Match</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Use smart filters and advanced search to connect with the right one
          </p>
        </div>

        {/* Enhanced Search Card */}
        <Card className="mb-8 border-0 shadow-2xl bg-white/80 backdrop-blur-sm rounded-2xl overflow-hidden">
          <CardContent className="p-0">
            {/* Quick Search Bar */}
            <div className="py-16 px-4 sm:px-6 lg:px-8 bg-maroon-gradient text-white">
              <div className="max-w-4xl mx-auto">
                <Label
                  htmlFor="search"
                  className="text-white font-semibold text-lg mb-4 block text-center"
                >
                  Start Your Search Journey
                </Label>
                <div className="flex gap-3" style={{ height: "50px" }}>
                  <div className="flex-1 relative">
                    {/* <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" /> */}
                    <Input
                      id="search"
                      placeholder="Search by name, location"
                      value={searchQuery}
                      style={{ height: "40px" }}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      className="pl-12 pr-4 py-5 text-lg text-black border-0 shadow-lg rounded-xl bg-white focus:ring-2 focus:ring-red-300"
                    />
                  </div>
                  <Button
                    style={{ height: "40px" }}
                    onClick={
                      token
                        ? handlefiltersearch
                        : () => setShowLoginDialog(true)
                    }
                    // style={{hover:"bg-redorange"}}
                    className="bg-white text-lg hover:bg-[#ff6a00] text-black px-6 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105 shadow-md cursor-pointer"
                  >
                    {/* <Zap className="w-5 h-5 mr-2" /> */}
                    Search
                  </Button>
                </div>
              </div>
            </div>

            {/* Advanced Filters Section */}
            <div className="p-6">
              <Collapsible
                open={isAdvancedOpen}
                onOpenChange={setIsAdvancedOpen}
              >
                <div className="text-center mb-3">
                  <CollapsibleTrigger asChild>
                    <Button
                      variant="outline"
                      className="border-2 border-dashed border-gray-300 bg-white hover:bg-gray-100 rounded-xl px-8 py-3 text-lg font-semibold transition-all duration-200 hover:border-red-300 cursor-pointer"
                    >
                      <SlidersHorizontal className="w-5 h-5 mr-3" />
                      Advanced Filters
                      <ChevronDown
                        className={`h-5 w-5 ml-2 transition-transform ${isAdvancedOpen ? "rotate-180" : ""
                          }`}
                      />
                    </Button>
                  </CollapsibleTrigger>
                </div>

                <CollapsibleContent className="space-y-8">
                  {/* Filter Grid */}
                  <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
                    {/* Left Column */}
                    <div className="space-y-6">
                      {/* Age Range */}
                      <div
                        className="bg-white rounded-2xl p-6 border border-red-100 shadow-sm h-[320px] flex flex-col justify-between"
                        style={{ height: "130px" }}
                      >
                        <div>
                          <div className="flex items-center gap-3 mb-4">
                            <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
                              <Cake className="w-5 h-5 text-[#e11d48]" />
                            </div>
                            <div>
                              <Label className="text-lg font-semibold text-gray-900 block">
                                Age Range
                              </Label>
                              <p className="text-sm text-gray-600">
                                Select preferred age range
                              </p>
                            </div>
                          </div>
                          <Slider
                            value={filters.ageRange}
                            onValueChange={(value) =>
                              setFilters({ ...filters, ageRange: value })
                            }
                            min={18}
                            max={60}
                            step={1}
                            className="mb-4 cursor-pointer"
                          />
                        </div>
                        <div className=" text-md flex justify-between items-center">
                          <div className="text-center">
                            <div className="text-md text-[#e11d48]">
                              Min Age: {filters.ageRange[0]}
                            </div>
                            {/* <div className="text-sm text-gray-500">Min Age</div> */}
                          </div>
                          <div className="w-8 h-0.5 bg-gray-300"></div>
                          <div className="text-center">
                            <div className="text-md  text-[#e11d48]">
                              <span
                                style={{
                                  fontSize: "small",
                                  fontWeight: "lighter",
                                }}
                              >
                                Max Age:
                              </span>{" "}
                              {filters.ageRange[1]}
                            </div>
                            {/* <div className="text-sm text-gray-500">Max Age</div> */}
                          </div>
                        </div>
                      </div>

                      {/* Religion */}
                      <div className="bg-white rounded-2xl p-6 border border-red-100 shadow-sm h-[320px]">
                        <div className="flex items-center gap-3 mb-4">
                          <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
                            <Target className="w-5 h-5 text-[#e11d48]" />
                          </div>
                          <div>
                            <Label className="text-lg font-semibold text-gray-900 block">
                              Religion
                            </Label>
                            <p className="text-sm text-gray-600">
                              Preferred religious background
                            </p>
                          </div>
                        </div>
                        <Input
                          placeholder="e.g., Hindu, Muslim, Christian..."
                          value={filters.religion}
                          onChange={(e) =>
                            setFilters({ ...filters, religion: e.target.value })
                          }
                          className="border-red-200 focus:border-[#e11d48] rounded-lg py-2"
                        />
                      </div>
                    </div>

                    {/* Right Column */}
                    <div className="space-y-6">
                      {/* Location */}
                      <div className="bg-white rounded-2xl p-6 border border-red-100 shadow-sm h-[320px]">
                        <div className="flex items-center gap-3 mb-4">
                          <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
                            <MapPin className="w-5 h-5 text-[#e11d48]" />
                          </div>
                          <div>
                            <Label className="text-lg font-semibold text-gray-900 block">
                              Location
                            </Label>
                            <p className="text-sm text-gray-600">
                              City, district or area
                            </p>
                          </div>
                        </div>
                        <Input
                          placeholder="e.g., Chennai, Madurai, Coimbatore..."
                          value={filters.location}
                          onChange={(e) =>
                            setFilters({ ...filters, location: e.target.value })
                          }
                          className="border-red-200 focus:border-[#e11d48] rounded-lg py-2"
                        />
                      </div>

                      {/* Education */}
                      <div className="bg-white rounded-2xl p-6 border border-red-100 shadow-sm h-[320px]">
                        <div className="flex items-center gap-3 mb-4">
                          <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
                            <GraduationCap className="w-5 h-5 text-[#e11d48]" />
                          </div>
                          <div>
                            <Label className="text-lg font-semibold text-gray-900 block">
                              Education
                            </Label>
                            <p className="text-sm text-gray-600">
                              Educational qualification
                            </p>
                          </div>
                        </div>
                        <Input
                          placeholder="e.g., Engineering, MBA, Doctor..."
                          value={filters.education}
                          onChange={(e) =>
                            setFilters({
                              ...filters,
                              education: e.target.value,
                            })
                          }
                          className="border-red-200 focus:border-[#e11d48] rounded-lg py-2"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="flex justify-center gap-4 pt-6  border-gray-200">
                    <Button
                      style={{ width: "150px" }}
                      onClick={
                        token ? handleSearch : () => setShowLoginDialog(true)
                      }
                      className="bg-maroon-gradient hover:bg-maroon-gradient text-white px-10 py-3 rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl transition-all duration-200 hover:scale-105 cursor-pointer"
                    >
                      {/* <Target className="w-5 h-5 mr-2" /> */}
                      Apply Filters
                    </Button>
                    <Button
                      variant="outline"
                      onClick={() => {
                        setSearchQuery("");
                        setFilters({
                          ageRange: [18, 50],
                          location: "",
                          religion: "",
                          education: "",
                        });
                        setSearchResults([]);
                        setShowsearch(false);
                      }}
                      className="border-2 border-gray-300 text-gray-700 hover:bg-gray-50 px-8 py-3 rounded-xl font-semibold transition-all duration-200 cursor-pointer"
                    >
                      Reset All
                    </Button>
                  </div>
                </CollapsibleContent>
              </Collapsible>
            </div>
          </CardContent>
        </Card>

        {/* Search Results */}
        {showsearch && (
          <div className="mb-6">
            <h2 className="text-2xl font-semi-bold mb-1">Search Results</h2>
            <p className="text-muted-foreground">
              {searchResults.length} profiles found
            </p>
          </div>
        )}

        {showsearch && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            {searchResults.map((profile) => (
              <ProfileCard
                key={profile._id}
                profile={profile}
                onNavigate={onNavigate}
              />
            ))}
          </div>
        )}

        {showsearch && searchResults.length === 0 && (
          <div className="text-center py-12">
            <Search className="h-12 w-12 mx-auto text-muted-foreground mb-4" />
            <h3 className="text-lg mb-2">No profiles found for Search</h3>
            <p className="text-muted-foreground mb-4">
              Try adjusting your search criteria or filters
            </p>
            <Button
              variant="outline"
              className="cursor-pointer"
              onClick={() => {
                setSearchQuery("");
                setFilters({
                  ageRange: [18, 50],
                  location: "",
                  religion: "",
                  education: "",
                });
                setSearchResults([]);
                setShowsearch(false);
              }}
            >
              Clear All Filters
            </Button>
          </div>
        )}

        {/* Featured Profiles Section */}
        <section className="py-12">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-semibold mb-4">Featured Profiles</h2>
            <p className="text-muted-foreground max-w-2xl mx-auto">
              Discover verified profiles of potential life partners who share
              your values and interests
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {profileList.length > 0 ? (
              // If no token, show only first 10 profiles, otherwise show all profiles from backend
              (!token ? profileList.slice(0, 10) : profileList).map(
                (profile) => (
                  <ProfileCard
                    key={profile._id}
                    profile={profile}
                    onNavigate={onNavigate}
                  />
                )
              )
            ) : (
              <p className="text-center col-span-full text-gray-500">
                No profiles found.
              </p>
            )}
          </div>

          {count !== page && (
            <div className="text-center mt-8">
              <button
                className="bg-maroon-gradient text-primary-foreground px-8 py-3 rounded-lg hover:bg-maroon-gradient transition-colors cursor-pointer"
                onClick={() => {
                  setCount(count + 1);
                  if (!token) {
                    setShowLoginDialog(true);
                  }
                }}
              >
                View More Profiles
              </button>
            </div>
          )}
        </section>

        <AlertDialog open={showLoginDialog} onOpenChange={setShowLoginDialog}>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>You’re Almost There!</AlertDialogTitle>
              <AlertDialogDescription>
                Log in to explore profiles and start connecting
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel
                onClick={() => setShowLoginDialog(false)}
                className="cursor-pointer"
              >
                Cancel
              </AlertDialogCancel>
              <AlertDialogAction
                className="bg-maroon-gradient hover:bg-maroon-gradient cursor-pointer"
                onClick={() => {
                  setShowLoginDialog(false);
                  onNavigate("login");
                }}
              >
                Login
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </div>
      <Footer />
    </div>
  );
}




